import { z } from 'zod';
import { listSearchSchema } from '@/utils/listSearch';

export const pendingSummaryRowSchema = z.object({
  reportingName: z.string(),
  reportingHrEmpId: z.string().nullable(),
  reportingMobile: z.string().nullable(),
  entryPersonQty: z.number(),
  dcrPending: z.number(),
  dcrOfflinePending: z.number(),
  derPending: z.number(),
  derOfflinePending: z.number(),
  total: z.number(),
});

export const pendingSummaryResponseSchema = z.object({
  items: z.array(pendingSummaryRowSchema),
  meta: z.object({
    fiscalYear: z.string().nullable(),
    totals: z.object({
      entryPersonQty: z.number(),
      dcrPending: z.number(),
      dcrOfflinePending: z.number(),
      derPending: z.number(),
      derOfflinePending: z.number(),
      total: z.number(),
    }),
  }),
});

export type PendingSummaryRow = z.infer<typeof pendingSummaryRowSchema>;
export type PendingSummaryResponse = z.infer<typeof pendingSummaryResponseSchema>;

export const pendingSummarySearchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export const pendingSummaryPageSearchSchema = pendingSummarySearchSchema.extend({
  ...listSearchSchema.shape,
});

export type PendingSummarySearch = z.infer<typeof pendingSummarySearchSchema>;

export const PENDING_COLUMNS = [
  { key: 'dcrPending', label: 'DCR Pending' },
  { key: 'dcrOfflinePending', label: 'DCR Offline Pending' },
  { key: 'derPending', label: 'DER Pending' },
  { key: 'derOfflinePending', label: 'DER Offline Pending' },
] as const;
